import { Card, Skeleton } from "@mantine/core";

export default function BulkStatCardSkeleton() {
  return (
    <Card radius="lg" className="min-h-[140px] p-5 sm:p-6">
      <div className="flex flex-col h-full">
        <div className="flex items-start justify-between">
          <Skeleton height={36} width={36} radius="md" />
          <Skeleton height={14} width={80} radius="sm" />
        </div>
        <div className="mt-4">
          <Skeleton height={12} width={100} radius="sm" className="mb-2" />
          <Skeleton height={32} width={70} radius="sm" />
        </div>
      </div>
    </Card>
  );
}
